import * as React from "react";
import "./Spinner.css";

interface ISpinnerProps {
    showCircleOnly?: boolean;
    circleSize?: number;
    style?: {}
}

function Spinner(p: ISpinnerProps) {

    const circleSize = p.circleSize ? p.circleSize : 60;
    const borderSize = circleSize / 6.0;

    if (p.showCircleOnly) {
        return (
            <div className="spinner-circle spinner-black"
                style={{ width: circleSize + "px", height: circleSize + "px", borderWidth: borderSize + "px", ...p.style }} />
        );
    }

    // Need to set the height of the spinner overlay dynamically based on the document height.  
    // Otherwise the overlay won't expand to cover pages that grow dynamically.
    const body = document.body;
    const html = document.documentElement;
    const height: number | string = Math.max(body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight);
    return (
        <div className="row align-items-center spinner-container-overlay" style={{ height, ...p.style }}>
            <div className="col offset-sm-5">
                <div className="spinner-circle spinner-white"
                    style={{ width: circleSize + "px", height: circleSize + "px", borderWidth: borderSize + "px" }} />
            </div>
        </div>
    );
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/core/Spinner/Spinner.tsx